import { notify } from 'utils/reduxUtils';

export const types = {
  INIT_LOGIN_INFO: 'auth/userProfile/INIT_LOGIN_INFO',
  FETCH_LOGIN_INFO_SUCCESS: 'auth/userProfile/FETCH_LOGIN_INFO_SUCCESS',
  FETCH_LOGIN_INFO_ERROR: 'auth/userProfile/FETCH_LOGIN_INFO_ERROR',

  LOGOUT_ALL_SESSIONS_REQUEST: 'auth/userProfile/LOGOUT_ALL_SESSIONS_REQUEST',
  LOGOUT_ALL_SESSIONS_SUCCESS: 'auth/userProfile/LOGOUT_ALL_SESSIONS_SUCCESS',
  LOGOUT_ALL_SESSIONS_ERROR: 'auth/userProfile/LOGOUT_ALL_SESSIONS_ERROR',
};

export const loginInfo = {
  init: () => ({
    type: types.INIT_LOGIN_INFO,
  }),
  success: ({ loginActivity }) => ({
    type: types.FETCH_LOGIN_INFO_SUCCESS,
    payload: { loginActivity },
  }),
  error: notify(
    (error) => ({
      type: types.FETCH_LOGIN_INFO_ERROR,
      payload: error,
    }),
    'Unable to fetch login activity',
  ),
};

export const logoutAll = {
  request: (didSessionExpire = false) => ({
    type: types.LOGOUT_ALL_SESSIONS_REQUEST,
    payload: { didSessionExpire },
  }),
  success: notify(
    () => ({
      type: types.LOGOUT_ALL_SESSIONS_SUCCESS,
    }),
    'Success',
    'Logged out',
  ),
  error: notify(
    (error) => ({
      type: types.LOGOUT_ALL_SESSIONS_ERROR,
      payload: error,
    }),
    'Unable to log out all sessions',
  ),
};
